import { SharedDocumentsPackage } from "../shared-documents-package";
import { DocumentsPackageHistoryRecord } from "../shared-documents-package-history";
import { UnityConnectTransaction } from "./unity-connect-transaction";


export class UnityConnectDocumentsTransaction extends UnityConnectTransaction{
    public documents: any[] = [];
    static fromShared(sdp: SharedDocumentsPackage, sdph?: DocumentsPackageHistoryRecord): UnityConnectDocumentsTransaction {
        
        const unityConnectTransaction = <UnityConnectDocumentsTransaction> UnityConnectTransaction.fromShared(sdp, sdph);

        unityConnectTransaction.documents = sdp.documents;

        return unityConnectTransaction;
    }
}